export class AccountRegistration {
    public firstName: string;
    public lastName: string;
    public email: string;
    public password: string;
    public acceptedTermsAndConditions: boolean;
    public promoEmailSubscribe: boolean;
}
